import React from 'react';

import type { FlowComponentRenderProps, TextComponentConfig } from '../types';
import HtmlText from './HtmlText';

const variantByType: Record<TextComponentConfig['type'], 'h2' | 'h3' | 'h4' | 'h5' | 'body2'> = {
  h1: 'h2',
  h2: 'h3',
  h3: 'h4',
  h4: 'h5',
  subheader: 'body2',
};

const fontSizeByType: Record<
  TextComponentConfig['type'],
  Record<NonNullable<TextComponentConfig['size']>, number>
> = {
  h1: {
    compact: 24,
    standard: 24,
    hero: 32,
  },
  h2: {
    compact: 24,
    standard: 24,
    hero: 32,
  },
  h3: {
    compact: 19,
    standard: 22,
    hero: 25,
  },
  h4: {
    compact: 16,
    standard: 18,
    hero: 21,
  },
  subheader: {
    compact: 14,
    standard: 16,
    hero: 18,
  },
};

const fontWeightByType: Record<TextComponentConfig['type'], number> = {
  h1: 800,
  h2: 800,
  h3: 700,
  h4: 700,
  subheader: 400,
};

const TextBlock: React.FC<FlowComponentRenderProps<TextComponentConfig>> = ({ config }) => {
  const isSubheader = config.type === 'subheader';
  const size = config.size ?? 'standard';
  const component = config.type === 'subheader' ? 'div' : config.type;

  return (
    <HtmlText
      component={component}
      html={config.text}
      variant={variantByType[config.type]}
      sx={{
        color: isSubheader ? 'var(--cx-brand-text-muted)' : 'var(--cx-brand-text)',
        fontFamily:
          config.type === 'h1' || config.type === 'h2'
            ? 'var(--cx-brand-font-family, Barlow, "Public Sans Variable", Arial, sans-serif)'
            : undefined,
        fontSize: fontSizeByType[config.type][size],
        fontWeight: isSubheader && size === 'hero' ? 500 : fontWeightByType[config.type],
        lineHeight: isSubheader ? '24px' : 1.2,
        textAlign: config.align ?? 'left',
      }}
    />
  );
};

export default TextBlock;
